// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bac710ac","455":"a36665a3","561":"ffc30d68","815":"f86183f5","955":"344a1a9f","962":"6f3a2174","977":"59fb7421"}[chunkId] + ".chunk.js";
};